/**
 * @fileoverview ContentSettings - Content management settings page
 * Groups Help Center and Document Requirements into a single page with tabs
 */
import React from "react";
import { intl, DmsTabber, DmsPage, DmsAltBox } from "dmsbasereact";
import { Typography } from "@mui/material";
import { HelpCenterSettings } from "../HelpCenterSettings/HelpCenterSettings";
import { DocumentSettings } from "../DocumentSettings/DocumentSettings";
import { Permissions } from "../../constants/Permissions";

export const ContentSettings = () => {
    const tabs = [
        {
            title: intl.get("HelpCenter").d("Help Center"),
            component: <HelpCenterSettings />,
            permissions: [Permissions.CAN_MANAGE_HELP_CENTER]
        },
        {
            title: intl.get("Documents").d("Documents"),
            component: <DocumentSettings />,
            permissions: [Permissions.CAN_MANAGE_GENERAL_SETTINGS]
        }
    ];

    return (
        <DmsPage name="Content Settings" manual_slug="content-settings">
            <DmsAltBox.Card>
                <DmsAltBox.Header>
                    <Typography variant='h3' sx={{ fontSize: '1.1rem' }}>
                        {intl.get("ContentSettings").d("Content Settings")}
                    </Typography>
                </DmsAltBox.Header>
                <DmsAltBox.Body>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        {intl.get("ContentSettingsDescription").d(
                            "Manage help center content and document requirements for user registration."
                        )}
                    </Typography>
                    <DmsTabber tabs={tabs} pageName={intl.get("ContentSettings").d("Content Settings")} variant="scrollable" />
                </DmsAltBox.Body>
            </DmsAltBox.Card>
        </DmsPage>
    );
};
